module.exports = __webpack_public_path__ + "img/bg-1.83131803.png";